function resolvePortalSlug(hintSlug) {
  let slug = typeof hintSlug === 'string' ? hintSlug.trim() : '';
  if (!slug && typeof sessionStorage !== 'undefined') {
    try {
      const stored = sessionStorage.getItem('lastPortalSlug');
      slug = typeof stored === 'string' ? stored.trim() : '';
    } catch {
      slug = '';
    }
  }
  return slug;
}

function portalLogonPathFromSlug(slug) {
  if (!slug) return '/login';
  return `/${encodeURIComponent(slug)}/logon`;
}

/**
 * Client-area “sign in” target when no JWT (errors, fallbacks): portal logon if slug is known.
 * @param {string} [hintSlug] – e.g. `portalSlug` / `slug` query param or `user.portalSlug`
 */
export function getClientAreaSignInPath(hintSlug) {
  return portalLogonPathFromSlug(resolvePortalSlug(hintSlug));
}

/**
 * Where to send the user after auth loss (401 / expired token / invalid JWT treated like 403 in api).
 * Uses `user.portalSlug` (e.g. `client` / `client_portal` JWT) then `sessionStorage.lastPortalSlug`.
 * When a slug exists → `/:slug/logon`; otherwise `/login`.
 */
export function getAuthFailureRedirectPath(user) {
  const fromUser =
    typeof user?.portalSlug === 'string' ? user.portalSlug.trim() : '';
  const slug = fromUser ? resolvePortalSlug(fromUser) : resolvePortalSlug();

  return portalLogonPathFromSlug(slug);
}
